import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ReportService } from "../../../Report/report.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import * as moment from "moment";

@Component({
	selector: "app-account-summary-report",
	templateUrl: "./account-summary-report.component.html",
	styleUrls: ["./account-summary-report.component.css"],
})
export class AccountSummaryReportComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,

		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private reportService: ReportService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.School = school;
			// this.onSchoolChange(school.SchoolID);
		});

		// this.lstSchool = this.dialogConfig.data.lstSchool;
		// this.SchoolID = this.lstSchool[0].SchoolID;
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	user: any;

	School: any;
	lstSchool: any = [];

	AccountTypeID: any = 1;
	lstType: any = [
		{
			ID: 1,
			Desc: "Fines",
		},
		{
			ID: 2,
			Desc: "Meals",
		},
	];

	IsOwedByStudent: any = "1";

	LastFineMeal: Date = new Date();

	isProcessing: any;
	errorMessage: any;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onPrint() {
		this.errorMessage = "";

		var component = this;

		this.isProcessing = true;

		var strParam = this.AccountTypeID + "|AccountID";
		strParam += "," + this.IsOwedByStudent + "|IsOwedByStudent";
		strParam += "," + moment(this.LastFineMeal).format("MM/DD/YYYY") + "|LastTransactionDate";
		strParam += "," + this.School.SchoolID + "|SchoolID";

		var reportID = 351;

		var result = this.reportService.Print(reportID, strParam, this.School.SchoolID, 1);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	onClose() {
		this.ref.close(this.School);
	}
	////////////////////////////////////////////
}
